// extracted by mini-css-extract-plugin
export default {"container":"side_bar_container__nrtQ2","menu_container":"side_bar_menu_container__yGK0K","menu_item_container":"side_bar_menu_item_container__s1Se0","icon":"side_bar_icon__Vd4sl"};